import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {black500} from "assets/jss/main";

import AccountCard from "./components/AccountCard";
import AlertsCard from "./components/AlertsCard";
import ContactCard from "./components/ContactCard";
import ConversationStatsCard from "./components/ConversationStatsCard";
import FactsCard from "./components/FactsCard";
import HistoryCard from "./components/HistoryCard";
import PrivacyCard from "./components/PrivacyCard";
import ProductsSentCard from "./components/ProductsSentCard";
import ProfileCard from "./components/ProfileCard";
import PurchasesCard from "./components/PurchasesCard";

CustomerSheetPane.propTypes = {
    conversation: PropTypes.object.isRequired,
    messages: PropTypes.arrayOf(PropTypes.object).isRequired,
    live: PropTypes.object.isRequired,
    onErased: PropTypes.func.isRequired,
};

/**
 * The right column, the customer sheet: contact, what the conversation produced, the alerts,
 * the profile and facts the assistant keeps, the cards sent, the purchases, the history and
 * the GDPR actions.
 */
function CustomerSheetPane({conversation, messages, live, onErased}) {
    return (
        <div style={{minWidth: 0, maxHeight: "calc(100vh - 240px)", overflowY: "auto", paddingRight: "2px"}}>
            <div style={{fontWeight: 700, color: black500, fontSize: "16px", margin: "4px 0 12px"}}><FormattedMessage id="personalShopper.sheet.title" /></div>
            <ContactCard conversation={conversation} />
            <AccountCard account={conversation.account} accountLinked={!!conversation.customerId} />
            <ConversationStatsCard conversation={conversation} messages={messages} />
            <AlertsCard escalations={conversation.escalations || []} onHandle={live.handleEscalation} />
            <ProfileCard profile={conversation.profile} />
            <FactsCard facts={conversation.facts || []} onSave={live.putFact} onDelete={live.deleteFact} />
            <ProductsSentCard products={conversation.productsSent || []} accountLinked={!!conversation.customerId} />
            <PurchasesCard purchases={conversation.assistedPurchases || []} />
            <HistoryCard conversation={conversation} />
            <PrivacyCard
                conversation={conversation}
                onSetMarketingOptOut={live.setMarketingOptOut}
                onExport={live.getPersonalData}
                onErase={() => live.erase().then(onErased)}
            />
        </div>
    );
}

export default CustomerSheetPane;
